import { useAdministrativeContext } from '../../../../../../../pages/administrativePanel/administrativePanelContext'
import { SpaceLoader } from '../../../../../../loaders/spaceLoader'
import { InputCheck } from '../../../../../../Forms/InputCheck'
import { useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { AiOutlineArrowLeft } from 'react-icons/ai'
import { Button } from '../../../../../../Button'
import { Business } from './Business';

import { Container, ContainerButton, ButtonFetchMore, SelectAll } from './style';
import { useCallback } from 'react';


export function BusinessList({ 
    listSearchBusiness, setListSearchBusiness,
    seeMoreSearchBusiness,
    showingFilteredBusiness, 
    setShowingFilteredBusiness,
    pageSearch,
    searchLoading,
    setStatusSelected, 
}) {
    const { 
        applyingPreferences, 
        businessAdm, setBusinessAdm,
        getBusinessAdm, 
        quantityBusinessToFetch,
        loadingButtonSeeMore,
        listBusinessToFilter,
        nextPage,
        setFranchiseListCodesSelected 
    } = useAdministrativeContext()
    const [confirmBusinessListToFilter, setConfirmBusinessListToFilter] = useState(listBusinessToFilter.filter(code => businessAdm.some(bus => code === bus.idBusiness) ))
    const [checkAllBusiness, setCheckAllBusiness] = useState(businessAdm.every(bus => confirmBusinessListToFilter.some(cod => cod === bus.idBusiness)))
    const [checkFilteredBusiness, setCheckFilteredBusiness] = useState(listSearchBusiness.length > 0 
        ? listSearchBusiness.every(bus => confirmBusinessListToFilter.some(cod => cod === bus.idBusiness))
        : false
    )

    const dispatch = useDispatch()

    let businessVisible = showingFilteredBusiness ? listSearchBusiness : businessAdm
    let isButtonVisible = showingFilteredBusiness ?  pageSearch : nextPage
    

    const checkingBusiness = useCallback((business) => {
        const listCopy = [...confirmBusinessListToFilter]

        listCopy.push(business)

        setConfirmBusinessListToFilter(listCopy)
    }, [confirmBusinessListToFilter])


    const uncheckingBusiness = useCallback((business) => {
        const filterList = confirmBusinessListToFilter.filter(b => b !== business)

        setConfirmBusinessListToFilter(filterList)
    }, [confirmBusinessListToFilter])


    const controlCheckingBusiness = useCallback((isChecking, business) => {
        if(isChecking)
            checkingBusiness(business)
        else
            uncheckingBusiness(business)
    },[checkingBusiness, uncheckingBusiness])


    const updateBusinessAdm = useCallback((business) => {
        const previousBusinessAdm = [...businessAdm] 

        const nextBusinessAdm = previousBusinessAdm.map(b => {
            if(b.idBusiness === business.idBusiness)
                return business
            else
                return b
        })

        setBusinessAdm(nextBusinessAdm)
    }, [businessAdm, setBusinessAdm])


    const updateListSearchBusiness = useCallback((business) => {
        const previousListSearchBusiness = [...listSearchBusiness] 

        const nextListSearchBusiness = previousListSearchBusiness.map(b => {
            if(b.idBusiness === business.idBusiness)
                return business
            else
                return b
        })

        setListSearchBusiness(nextListSearchBusiness)
    }, [listSearchBusiness, setListSearchBusiness])


    const updateBusinessListWhenSetIdCustomizer = useCallback((business) => {
        if(showingFilteredBusiness)
            updateListSearchBusiness(business)
        else
            updateBusinessAdm(business)
    }, [showingFilteredBusiness, updateBusinessAdm, updateListSearchBusiness])


    function handleClickToApply() {
        applyingPreferences(1, confirmBusinessListToFilter)
        setFranchiseListCodesSelected([])
        dispatch({type: '', title: 'Filtrar empresas'})
    }

    function selectAllBusiness() {
        setCheckAllBusiness(!checkAllBusiness)

        if(checkAllBusiness)
            setConfirmBusinessListToFilter([])
        else
            setConfirmBusinessListToFilter(businessAdm.map(bus => bus.idBusiness))
    }

    function handleSeeMore() {
        listSearchBusiness.length > 0 ? 
        seeMoreSearchBusiness() 
        :
        getBusinessAdm(false, quantityBusinessToFetch + 20)
    }

    function selectAllFilteredBusiness() {
        let array = listSearchBusiness.map(b => {return b.idBusiness})
        setCheckFilteredBusiness(!checkFilteredBusiness)

        if(checkFilteredBusiness)
            setConfirmBusinessListToFilter([])
        else
            setConfirmBusinessListToFilter(array)
    }
   
    useEffect(() => {
        
        getBusinessAdm(false, quantityBusinessToFetch)
      
        //eslint-disable-next-line
    }, [])

    useEffect(() => {
        setCheckAllBusiness(businessAdm.every(bus => confirmBusinessListToFilter.some(cod => cod === bus.idBusiness)))
    }, [confirmBusinessListToFilter, businessAdm])

    useEffect(() => {
        setCheckFilteredBusiness(listSearchBusiness.length > 0 
            ? listSearchBusiness.every(bus => confirmBusinessListToFilter.some(cod => cod === bus.idBusiness))
            : false
        )
    }, [confirmBusinessListToFilter, listSearchBusiness])
    
    useEffect(() => {
        if(showingFilteredBusiness)
            setConfirmBusinessListToFilter([])
    }, [showingFilteredBusiness, listSearchBusiness])
   

   
    if(searchLoading)
        return <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" />

    return(
        <Container>
            {
                showingFilteredBusiness ?
                <div 
                    className="arrowBack"
                    onClick={() => {
                        setShowingFilteredBusiness(false)
                        setStatusSelected(0)
                        getBusinessAdm(false, quantityBusinessToFetch)
                    }}
                >
                    <AiOutlineArrowLeft />
                    Voltar
                </div>
                :
                <></>
            }
            
          
            <SelectAll>
                <InputCheck 
                    checked={showingFilteredBusiness ? checkFilteredBusiness : checkAllBusiness}
                    handleClick={showingFilteredBusiness ? selectAllFilteredBusiness : selectAllBusiness}
                /> 
                <p> Selecionar todas</p>
            </SelectAll>
            

            {
                businessVisible.map((business) => (
                    
                    <Business 
                        key={business.idBusiness}
                        business={business}
                        confirmBusinessListToFilter={confirmBusinessListToFilter}
                        updateBusinessListWhenSetIdCustomizer={updateBusinessListWhenSetIdCustomizer}
                        controlCheckingBusiness={controlCheckingBusiness}
                    />  
                        
                ))
            }


           {isButtonVisible &&
                <ButtonFetchMore 
                    isLoading={loadingButtonSeeMore}
                    onClick={handleSeeMore}
                >
                    {
                        loadingButtonSeeMore ? 
                        'Aguarde...'
                        :
                        'Ver mais'
                    }
                </ButtonFetchMore>
            }


            <ContainerButton isDisabled={confirmBusinessListToFilter.length === 0}>
                <Button 
                    background="#7A05A7"
                    color="#FFF"
                    onClick={handleClickToApply}
                >
                    Aplicar
                </Button>
            </ContainerButton>
            
        </Container>
    )
}